import * as z from "zod";
import { attachmentSchema, dateSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemaFormConstat = z.object({
  eventType: z.literal("CONSTAT"),
  name: zRequiredString("Veuillez dÃ©finir un nom").max(50, {
    message: "Maximum 50 caractÃ¨res",
  }),
  description: zRequiredString(
    "Veuillez dÃ©finir une description du constat",
  ),
  site: zRequiredString("Veuillez dÃ©finir un site"),
  localisation: z.string().optional(),
  dateEvt: dateSchema,
  audit: zRequiredString("Veuillez dÃ©finir un audit"),
  pilote: zRequiredString("Veuillez dÃ©finir un pilote"),
  gravity: zRequiredString("Veuillez dÃ©finir la gravitÃ©"),
  needsCauseAnalysis: z.boolean(),
  needsActions: z.boolean(),
  attachedFiles: attachmentSchema,
});
